import d from '../FetchDesign.module.css';
import { useFetchDesign } from '../fetchDesign';
import { FetchTagIcon } from './FetchTagIcon';

// The collapsed mobile panel's header: the tag icon and the arm's label. The
// icon is the same in every arm; only the words differ (2.x's header is its
// "For pet parents" bar, control and 1.x keep "You've unlocked this offer").
export function FetchPanelLabel() {
  const { panelLabel } = useFetchDesign();
  return (
    <span className={d.panelTagged}>
      <FetchTagIcon className={d.panelTagIcon} />
      {panelLabel}
    </span>
  );
}
